import {Component, input} from '@angular/core';
import {CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray} from '@angular/cdk/drag-drop';
import {FieldsConfigSwitch} from './fields-config-switch';
import {FormService} from '../services/FormService';
import {IYii} from '../../../globals';
import {NgClass} from '@angular/common';
import {Button} from 'primeng/button';

declare var Yii: IYii;

@Component({
  selector: 'ng-fields-content',
  imports: [
    CdkDrag,
    CdkDragHandle,
    CdkDropList,
    FieldsConfigSwitch,
    NgClass,
    Button
  ],
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `],
  template: `
    <div class="fields-content">
      @if (!fsvc.form_json?.form_fields?.length) {
        <p>{{ Yii.t('app', 'No fields added yet.') }}</p>
      }
      <div cdkDropList (cdkDropListDropped)="drop($event)" style="display: flex; flex-direction: column;gap: 2px">
        @for (field of fsvc.form_json.form_fields; track field.field_id) {
          <div cdkDrag class="sortable-item" [id]="field.field_id" style="border: solid 1px #c5d0dc; overflow: hidden;">
            <div
              (click)="field.isOpen = !field.isOpen"
              cdkDragHandle
              style="background-color: #f1f9ff; padding:8px; gap:8px; cursor: move; display: flex; align-items: center; justify-content: space-between;">
              <div style="display: flex; gap: 8px; align-items: center;">
                <small>#{{ field.field_id }}</small>
                <strong style="color: #333;font-size: 1.25rem">
                  {{ (field.field_title) ? field.field_title : 'Field-' + (field.field_id + 1) }}
                </strong>
                <small>{{ field.field_type }}</small>
              </div>
              <div>
                @if (field.isOpen) {
                  <i class="fa fa-angle-up"></i>
                } @else {
                  <i class="fa fa-angle-down"></i>
                }
              </div>
            </div>
            @if (field.isOpen) {
              <div
                class="flex-row flex-align-center flex-justify-between"
                style="margin-bottom: 1rem;border-bottom: 1px solid #c5d0dc; padding: 0 1rem;background-color: #f1f9ff44">
                <div>
                  <strong>{{ field.field_type }}</strong>
                </div>
                <div>
                  <p-button
                    icon="fa fa-trash"
                    size="small"
                    variant="text"
                    [label]="Yii.t('app', 'Delete')"
                    (click)="fsvc.DeleteField(field.field_id)"
                  />
                  <!--Duplicate Field -->
                  &nbsp;
                  <p-button
                    icon="fa fa-copy"
                    variant="text"
                    severity="warn"
                    [label]="Yii.t('app', 'Duplicate')"
                    (click)="fsvc.DuplicateField(field)">
                  </p-button>
                </div>
              </div>
              <div style="padding: 15px;">
                <ng-fields-config-switch
                  [ngClass]="{'fields-mode-split':previewMode() == 'split'}"
                  [field]="field"
                />
              </div>
            }
          </div>
        }
      </div>
    </div>
  `
})
export class FieldsContent {
  Yii = Yii;

  previewMode = input<string>('fields');

  constructor(
    public fsvc: FormService) {

  }

  drop(event: CdkDragDrop<any[]>) {
    if (this.fsvc.form_json?.form_fields) {
      moveItemInArray(this.fsvc.form_json.form_fields, event.previousIndex, event.currentIndex);
    }
  }

}
